export enum FeatureToggle {
  ordersOperationalDashboard = 'rt_orders_operational_dashboard',
  ordersOperationalDashboardRouletteToggle = 'rt_ops_dashboard_offer_explainability',
  businessOrderingTool = 'rt_business_ordering_tool',
  orderDetailsChatMessages = 'rt_ops_dashboard_order_details_chat_messages',
  orderDetailsProductCatalogLinks = 'rt_ops_dashboard_order_details_product_catalog_links',
}
